import _ from 'lodash';

export default class MrtApi {
    static createUrl(urlBase, sections = [], params = {}, hash = '') {
        if (!urlBase) {
            throw new Error('Cannot create URL from empty base');
        }

        let url = urlBase;

        if (sections.length > 0) {
            url += '/' + sections.join('/');
        }

        if (_.size(params) > 0) {
            url += '?';
            let keyValues = [];
            for (const paramKey in params) {
                keyValues.push(paramKey + '=' + encodeURIComponent(params[paramKey]));
            }

            url += keyValues.join('&');
        }

        if (hash) {
            url += '#' + hash;
        }

        return url;
    }

    static createUrlForRoute(routeName, sections = [], params = {}, hash = '') {
        let route = Mrt.config.routes[routeName];
        if (!route) {
            throw new Error(`Route ${routeName} not declared.`);
        }

        return MrtApi.createUrl(route, sections, params, hash);
    }
}
